import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3faac043")

_pushScopeId("data-v-3faac043")
const _hoisted_1 = { class: "top-line main-top-line" }
const _hoisted_2 = { class: "container main-top-line" }
const _hoisted_3 = { class: "row align-items-center navbar-expand-sm" }
const _hoisted_4 = { class: "col-1 d-flex align-items-center" }
const _hoisted_5 = { class: "col-7 justify-content-center align-self-stretch" }
const _hoisted_6 = { class: "col-4 d-flex align-items-center justify-content-between" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MainLogo = _resolveComponent("MainLogo")
  const _component_MenuDesktopList = _resolveComponent("MenuDesktopList")
  const _component_SearchBlock = _resolveComponent("SearchBlock")
  const _component_RegionSelect = _resolveComponent("RegionSelect")
  const _component_SwitchLanguage = _resolveComponent("SwitchLanguage")
  const _component_ProfileMenu = _resolveComponent("ProfileMenu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_MainLogo)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_MenuDesktopList, { class: "header__menu" })
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_SearchBlock),
          _createVNode(_component_RegionSelect),
          _createVNode(_component_SwitchLanguage),
          _createVNode(_component_ProfileMenu)
        ])
      ])
    ])
  ]))
})